import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';

/** Ressource portant l'annotation `platform.io/has-redis: "true"`. */
const hasRedis = (entity: {
  kind: string;
  metadata: { annotations?: Record<string, string> };
}) =>
  entity.kind === 'Resource' &&
  entity.metadata.annotations?.['platform.io/has-redis'] === 'true';

const redisContent = EntityContentBlueprint.make({
  name: 'redis',
  params: {
    path: '/redis',
    title: 'Redis',
    filter: hasRedis,
    loader: () => import('./RedisPanel').then(m => <m.RedisPanel />),
  },
});

/**
 * Carte de la vue d'ensemble : les cartes génériques du catalogue sont retirées
 * pour les ressources `cache` (app-config.yaml), celle-ci les remplace.
 */
const redisOverviewCard = EntityCardBlueprint.make({
  name: 'overview',
  params: {
    type: 'content',
    filter: hasRedis,
    loader: () => import('./RedisOverviewCard').then(m => <m.RedisOverviewCard />),
  },
});

export default createFrontendPlugin({
  pluginId: 'redis-browser',
  extensions: [redisOverviewCard, redisContent],
});
